import React, { useState } from "react";
import Contact from "../contact";
import Testimonials from "../Testimonials";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/visa-assistance-image.png";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/immigetHelp.png";
import { FaPlus, FaTimes, FaExclamationTriangle, FaClock, FaGavel, FaShieldAlt, FaUsers, FaFileAlt, FaBan, FaCheckCircle, FaUserTimes, FaBalanceScale } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import { Helmet } from "react-helmet-async";

const VisaCancellations = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const testimonials = [
    {
      name: "Michael T.",
      content: "Facing deportation after 15 years in Australia over a minor offense. Immiget got my visa reinstated through AAT appeal.",
      rating: 5
    },
    {
      name: "Priya K.", 
      content: "Student visa cancelled due to attendance issues. We proved college errors and got visa restored in 3 weeks.",
      rating: 5
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Visa Cancellations Australia - Defense & Reinstatement - Immiget Global</title>
        <meta name="description" content="Australian visa cancelled or at risk? 80% success rate overturning cancellations. 24/7 emergency service. Expert defense against character, compliance & Section 501 cancellations." />
        <meta name="keywords" content="visa cancellation australia, visa cancelled, section 501, AAT appeal, visa reinstatement, character cancellation, immigration lawyer australia" />
      </Helmet>

      {/* Hero Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex max-xl:flex-col justify-between max-xl:gap-6 xl:gap-[80px] xl:items-center">
          <div className="xl:w-[50%]">
            <h1 className="xl:text-[28px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
              Visa Cancellations in Australia – How to Protect or Reinstate Your Visa
            </h1>
            <p className="max-xl:text-center hellix-font text-blue text-lg xl:text-[20px] font-normal">
              Has your Australian visa been cancelled or are you at risk? Visa cancellations can happen suddenly, leaving you with limited time to respond. At Immiget Global, our specialist cancellation lawyers have successfully overturned 80% of cancellations when engaged early enough.
            </p>
          </div>
          <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
            <img src={visaImage} alt="Visa Cancellations" />
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Understanding Visa Cancellations */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Understanding Visa Cancellations
          </h1>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Common Reasons */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <h3 className="text-blue text-2xl font-semibold hellix-font mb-6 flex items-center gap-3">
              <FaExclamationTriangle className="text-red-500" />
              Common Reasons for Visa Cancellation
            </h3>
            <div className="space-y-4">
              {[
                { icon: FaUserTimes, text: "Character grounds (criminal convictions)" },
                { icon: FaBan, text: "Breach of visa conditions (working illegally, overstaying)" },
                { icon: FaFileAlt, text: "False information in applications" },
                { icon: FaExclamationTriangle, text: "Changed circumstances affecting eligibility" },
                { icon: FaShieldAlt, text: "Health risks to Australian community" }
              ].map((reason, index) => {
                const IconComponent = reason.icon;
                return (
                  <div key={index} className="flex items-start gap-3">
                    <IconComponent className="text-red-500 text-lg mt-1 flex-shrink-0" />
                    <span className="text-blue hellix-font">{reason.text}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Types of Cancellations */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <h3 className="text-blue text-2xl font-semibold hellix-font mb-6 flex items-center gap-3">
              <FaGavel className="text-blue" />
              Types of Cancellations
            </h3>
            <div className="space-y-4">
              <div className="p-4 bg-red-50 rounded-lg">
                <h4 className="text-blue font-semibold hellix-font mb-2">1. Automatic Cancellations</h4>
                <p className="text-blue text-sm hellix-font">e.g., prison sentences 12+ months</p>
              </div>
              <div className="p-4 bg-yellow-50 rounded-lg">
                <h4 className="text-blue font-semibold hellix-font mb-2">2. Discretionary Cancellations</h4>
                <p className="text-blue text-sm hellix-font">Department of Home Affairs decision</p>
              </div>
              <div className="p-4 bg-orange-50 rounded-lg">
                <h4 className="text-blue font-semibold hellix-font mb-2">3. Section 501 Cancellations</h4>
                <p className="text-blue text-sm hellix-font">serious character concerns</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Rights & Options */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Your Immediate Rights & Options
          </h1>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Critical Timeframes */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <h3 className="text-blue text-2xl font-semibold hellix-font mb-6 flex items-center gap-3">
              <FaClock className="text-red-500" />
              Critical Timeframes
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3 p-4 bg-red-50 rounded-lg">
                <FaClock className="text-red-500 text-lg mt-1 flex-shrink-0" />
                <div>
                  <span className="text-blue font-semibold hellix-font">28 days</span>
                  <p className="text-blue text-sm hellix-font">to apply for revocation of automatic cancellations</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-yellow-50 rounded-lg">
                <FaClock className="text-yellow-500 text-lg mt-1 flex-shrink-0" />
                <div>
                  <span className="text-blue font-semibold hellix-font">7-14 days</span>
                  <p className="text-blue text-sm hellix-font">to respond to Notice of Intention to Cancel (NOICC)</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-orange-50 rounded-lg">
                <FaClock className="text-orange-500 text-lg mt-1 flex-shrink-0" />
                <div>
                  <span className="text-blue font-semibold hellix-font">9 days</span>
                  <p className="text-blue text-sm hellix-font">for protection visa cancellations</p>
                </div>
              </div>
            </div>
          </div>

          {/* Possible Actions */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <h3 className="text-blue text-2xl font-semibold hellix-font mb-6 flex items-center gap-3">
              <FaCheckCircle className="text-green-500" />
              Possible Actions
            </h3>
            <div className="space-y-4">
              {[
                "Submission against cancellation (NOICC response)",
                "AAT Appeal (if cancellation stands)",
                "Ministerial Intervention (exceptional cases)",
                "Bridging visa application to remain lawful",
                "Reapplication strategy if cancellation upheld"
              ].map((action, index) => (
                <div key={index} className="flex items-start gap-3">
                  <FaCheckCircle className="text-green-500 text-lg mt-1 flex-shrink-0" />
                  <span className="text-blue hellix-font">{action}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Defense Process */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Our Visa Cancellation Defense Process
          </h1>
        </div>
        
        <div className="mt-6 space-y-6">
          {/* Step 1 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-lg font-bold hellix-font">1</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Urgent Case Assessment
              </h3>
            </div>
            <div className="ml-16 space-y-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">24/7 emergency consultations</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Immediate analysis of cancellation notice</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Strategy session within 24 hours</span>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-lg font-bold hellix-font">2</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                NOICC Response Preparation
              </h3>
            </div>
            <div className="ml-16 space-y-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Gathering counter-evidence</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Preparing legal submissions</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Character references & expert reports</span>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-lg font-bold hellix-font">3</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                AAT Appeal Representation
              </h3>
            </div>
            <div className="ml-16 space-y-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Full case preparation</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Hearing advocacy</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Fresh evidence presentation</span>
              </div>
            </div>
          </div>

          {/* Step 4 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-lg font-bold hellix-font">4</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Ministerial Intervention
              </h3>
            </div>
            <div className="ml-16 space-y-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">For cases with exceptional circumstances</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Compassionate/compelling arguments</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">High-level representations</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Us */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global for Cancellation Cases?
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaBalanceScale className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              80% Success Rate in overturning cancellations
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaShieldAlt className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              Former Immigration Compliance Officers on staff
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaClock className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              24/7 Emergency Service for sudden cancellations
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaUsers className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              Multilingual Team (12 languages spoken)
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaFileAlt className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              Fixed Fee Packages with payment plans
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Testimonials */}
      <div className="py-6 xl:py-10">
        <Testimonials testimonials={testimonials} title="Case Study: Recent Cancellation Wins" />
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Consequences */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Visa Cancellation Consequences
          </h1>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { icon: FaBan, text: "Re-entry bans (3-10 years)" },
            { icon: FaExclamationTriangle, text: "Future visa applications affected" },
            { icon: FaUsers, text: "Family visa impacts" },
            { icon: FaUserTimes, text: "Loss of work rights immediately" }
          ].map((consequence, index) => {
            const IconComponent = consequence.icon;
            return (
              <div key={index} className="bg-red-50 rounded-lg p-6 flex items-center gap-4">
                <IconComponent className="text-red-500 text-3xl flex-shrink-0" />
                <span className="text-blue text-lg font-semibold hellix-font">{consequence.text}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* CTA Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="bg-red-50 rounded-lg p-8 text-center">
          <h2 className="text-3xl text-blue font-bold hellix-font mb-4">
            Don't Delay – Act Now!
          </h2>
          <p className="text-blue text-lg hellix-font mb-6">
            Every hour counts after receiving a cancellation notice. Our cancellation specialists are available 24/7.
          </p>
          <button 
            onClick={scrollToContact}
            className="px-8 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
          >
            Get Emergency Consultation
          </button>
        </div>
      </div>

      {/* How We Help Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex max-lg:flex-col justify-between gap-6 lg:gap-[80px] lg:items-center">
          <div className="lg:w-[50%]">
            <div className="flex gap-2">
              <div className="flex items-center">
                <img src={helpIcon} alt="help" />
              </div>
              <h1 className="text-[26px] text-blue font-semibold hellix-font">
                How Immiget Global Can Help
              </h1>
            </div>
            <p className="hellix-font text-blue text-lg font-normal mt-4">
              Our experienced cancellation lawyers understand the urgency and stress of visa cancellations. We provide immediate response, strategic defense, and comprehensive support throughout the entire process. With former immigration officers on our team, we know how the system works and how to achieve the best outcomes for our clients.
            </p>
            <div className="flex gap-4 mt-6">
              <button 
                onClick={scrollToContact}
                className="px-6 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
              >
                Contact Us Today
              </button>
            </div>
          </div>
          <div className="lg:w-[50%] max-lg:justify-center max-lg:flex">
            <img src={helpImage} alt="How we can help" />
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default VisaCancellations;